import type { ChangeEvent } from 'react'
import { useEffect, useRef, useState } from 'react'
import { classNames, legacyContractDataAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { treeStore } from '@/msgdeskRuntime/state'
import { dispatchEditorAction } from '@/msgdeskRuntime/editorActions'
import { useEditorSurface } from '../../EditorSurfaceContext'

function useAvatarSrc() {
  const [src, setSrc] = useState(() => dispatchEditorAction({ action: 'current-avatar-src' }))

  useEffect(() => {
    return treeStore.subscribe(() => {
      const next = dispatchEditorAction({ action: 'current-avatar-src' })
      setSrc(current => current === next ? current : next)
    })
  }, [])

  return src
}

// Avatar fieldset — same React-owned upload model as attachments, but with a
// single image slot. The legacy save model is updated through the facade.
export function AvatarPanel() {
  const { skin } = useEditorSurface()
  const inputRef = useRef<HTMLInputElement>(null)
  const avatarSrc = useAvatarSrc()
  const classes = skin.settings

  const handlePick = () => inputRef.current?.click()
  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files?.[0]
    event.currentTarget.value = ''
    if (file) await dispatchEditorAction({ action: 'upload-avatar', file })
  }

  return (
    <fieldset {...legacyContractDataAttrs('editor.settings.avatar')} className={classes.panel}>
      <legend className={classes.legend}>Avatar</legend>
      <label className={classes.check}>
        <input type="checkbox" name="is_avatar" value="1" />
        Use avatar
      </label>
      <button type="button" className={classNames('md-settings__avatar-button', classes.avatarButton)} onClick={handlePick}>
        <img className={classNames('md-settings__avatar-image', classes.avatarImage)} src={avatarSrc} alt="" />
        <span>Upload</span>
      </button>
      <input ref={inputRef} type="file" className={classNames('md-settings__avatar-input', classes.avatarInput)} onChange={handleChange} />
    </fieldset>
  )
}
